import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { from, Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { APIService } from '../../api.service';
@Component({
  selector: 'app-rejections-reasons-config',
  templateUrl: './rejections-reasons-config.component.html',
  styleUrls: ['./rejections-reasons-config.component.scss']
})
export class RejectionsReasonsConfigComponent implements OnInit, AfterViewInit {

  constructor(private apiService: APIService, private modalService: NgbModal, private router: Router, private route: ActivatedRoute) { }
  changingValue: Subject<boolean> = new Subject();
  
  agencyData: any = [];
  jarvisData: any = [];
  reasons: any = [];
  isEdit: boolean = false;
  reason: string = '';
  code: string = '';
  ind: number = 0;
  @ViewChild('mymodal') addModalRef!: TemplateRef<any>;

    ngOnInit(): void {
      let agencyData = this.apiService.getCookie("M");
      if (agencyData) {
        this.agencyData = JSON.parse(agencyData);
      }
      var jarvis = this.apiService.getCookie("Jarvis");
      if (jarvis) {
        this.jarvisData = JSON.parse(jarvis);
      }

      this.getReasons()
    }

    ngAfterViewInit(): void {
      this.route.queryParams.subscribe(params => {
        if (params['o'] == '1') {
          setTimeout(() => {
            this.open(this.addModalRef, 0);
          }, 100);
        }
      });
    }

  
    // getUnits() - get all units from database
    getReasons(){
      let myParams = [{
          myUserID: this.jarvisData[0].UserID,
          myToken: this.jarvisData[0].WebToken,
          forAgencyID: this.jarvisData[0].AgencyIDs,
          myAgencyIDs: this.jarvisData[0].AgencyIDs,
          ForERPAgencyID: this.agencyData[0].ERPAgencyID,
          myLastSyncDT: null,
          isWeb: true,
          actionType: 'getConfig',
          moduleID: 6,
          data: ''
      }];
      this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));
    }
  
    //successResp - success  get handler
    successResp(res: any) {
      if (res.error) {
      }
      else {
          if (res) {
              var reponseData = JSON.parse(res.updatePackage);
              if (reponseData.Table2) {
                  let editDataArry = JSON.parse(reponseData.Table2[0].PrdRejnReasons);
                  for(let j = 0; j < editDataArry.length; j++){
                    this.reasons.push({
                      'RID': editDataArry[j].RID,
                      'Code': editDataArry[j].Code,
                      'Rsn': editDataArry[j].Rsn,
                      'Seq': editDataArry[j].Seq
                  });
                  }
                  
              }
          }
          this.reasons.sort((a:any,b:any) => a.Rsn.localeCompare(b.Rsn));
      }
    }

    //failureResp - failure handler
    failureResp(res: any) {
      if (res.error) {
      }
    }

  closeResult: any;
  modalReference: any;

    // open() - open edit reason and add new reason modal 
    open(content: any, id:number) { 
      this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'unitModal'});
        this.modalReference.result.then((result: any) => {
            this.closeResult = `Closed with: ${result}`;
        },
            (reason: any) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
        if(id == 0){
          this.isEdit = false;
          this.reason = '';
          this.code = '';
        }
        else if(id != 0){
          this.ind = id;
          var ReasonData = this.reasons.filter(function (element: any, index: any) {
            return (element.RID == id);
        });
            this.isEdit = true; 
            const reasonOld:string = ReasonData[0].Rsn;
            const codeOld: string = ReasonData[0].Code;
            this.reason = reasonOld;
            this.code = codeOld;
        }
      
    }

    private getDismissReason(reason: any): string {
      this.isEdit = false;
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        } 
    }

    public closeModal($event: any) {
      this.isEdit = false;
        this.modalReference.close();
        if ($event) {
            this.changingValue.next($event);
        }
    }

    // addReason() - add new reason
    addReason(rsn: string, code: string){
    var temp: any = []
    if(this.reasons.length > 20){
      alert("You can only add up to 20 reasons for rejection.")
      return;
    }
    if(rsn == ''){
      alert("Please enter reason name.")
      return;
    }
    if(code == ''){
      alert("Please enter reason code.")
      return;
    }
    let flag = false;
      temp = {
        RID: this.reasons.length + 1,
        Code: code,
        Rsn: rsn,
        Seq: this.reasons.length + 1
      }
    for (let i = 0; i < this.reasons.length; i++) {
      if(rsn.toUpperCase() == this.reasons[i].Rsn.toUpperCase()){
        flag = true
        alert("This reason already exists.")
        this.reason = '';
        this.code = '';
        break
        
      }
      else if(code.toUpperCase() == this.reasons[i].Code.toUpperCase()){
        flag = true
        alert("This reason code already exists.");
        this.reason = '';
        this.code = '';
        break
      }
    }
    
    if(!flag){
      this.reasons.push(temp);
      this.reason = '';
      this.save()
      this.modalReference.close();
    }
    }  
 
   // editReason() - Edit reason
    editReason(rsn: string, code: string){
      var editInd = this.ind;
      var ReasonData = this.reasons.filter(function (element: any, index: any) {
        return (element.RID == editInd);
      });
      if(rsn == ''){
        this.reason = ReasonData[0].Rsn;
        alert("Please enter reason.")
        return;
      }
      if(code == ''){
        this.reason = ReasonData[0].Rsn;
        alert("Please enter reason code.")
        return;
      }
      let flag = false;
      if(ReasonData[0].Rsn == rsn && ReasonData[0].Code == code){
        flag = false
      }
      else{
        for (let i = 0; i < this.reasons.length; i++) {
          if(ReasonData[0].RID != this.reasons[i].RID){
            if(rsn == this.reasons[i].Rsn){
              flag = true
              this.reason = ReasonData[0].Rsn;
              alert("This reason already exists.")
              break
            }
            else if(code == this.reasons[i].Code){
              flag = true
              this.code = ReasonData[0].Code;
              alert("This reason code already exists.")
              break
            }
          }
        }
      }
      
      if(!flag){
        for(let i = 0; i < this.reasons.length; i++){
          if(this.reasons[i].RID == ReasonData[0].RID){
            this.reasons[i].Rsn = rsn;
            this.reasons[i].Code = code;
            break
          }
        }
        //this.save();
        this.modalReference.close();
      }
     
    }

    // deleteReason() - delete reason
    deleteReason(id: number){
      if(confirm("Are you sure you want to delete this reason?")){
        this.reasons.splice(id, 1);
        this.save();
      }
    }

    // save final data
    save(){
      var tempData = [{
        'ChangeType': 'PRDREJN',
        'GSTLdgrs':'',
        'Units': '',
        'Stores':'',
        'ItemCategories': '',
        'PrdJobStages': '',
        'ValnMethod':1,
        'HSNSAC':'',
        'PrdRejnReasons': JSON.stringify(this.reasons),
    }]
    let myParams = [{
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        myLastSyncDT: null,
        isWeb: true,
        actionType: 'set',
        moduleID: 6,
        data: JSON.stringify(tempData)
    }];
    this.apiService.sendChange(myParams, this.successEdit.bind(this), this.failureResponse.bind(this));
    }

   //successVchrEntry - success voucher entry handler
   successEdit(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var ErpData = JSON.parse(res.updatePackage);
          if (ErpData.Table1) {
            let coockieData = [];
            coockieData.push(ErpData.Table1[0]);
            let ErpAgn = JSON.stringify(coockieData);
            localStorage.setItem("ERP_Agn", ErpAgn)
          }
          if (ErpData.Table2) {
            let cookieData2 = [];
            cookieData2.push(ErpData.Table2[0]);
            let ErpCfgData = JSON.stringify(cookieData2);
            localStorage.setItem("ERP_Cfg", ErpCfgData)
          }
    }
        this.reasons = [];
        this.getReasons();      
        this.modalReference.close();
    }
}

//failureResp - failure handler
failureResponse(res: any) {
  if (res.error) {
  }
  // else {
  //     alert(res.message);
  // }
}

    //back() - back to settings
    back(){
      this.router.navigate(['ProductionSettings']);
    }

    backBtn() {
      window.history.back();
    }

    // change color
changeColor(ind: any){
  var clr = ""
  switch(ind) { 

    case 0: { 
      clr = 'orangeBadge'
       break; 
    } 
    case 1: {
      clr = 'yellowBadge'
      break; 
    } 
    case 2: { 
      clr = 'greenBadge'
       break; 
    } 
    case 3: { 
      clr = 'tealBadge'
       break; 
    } 
    case 4: { 
      clr = 'blueBadge'
       break; 
    } 
    case 5: { 
      clr = 'darkBlueBadge'
       break; 
    } 
    case 6: { 
      clr = 'brownBadge'
       break; 
    } 
  
 }
 return clr; 
}

}
